export default __webpack_public_path__ + "static/media/activities.ab828706.png";